import script from "./enfooter.vue?vue&type=script&setup=true&lang=js"
export * from "./enfooter.vue?vue&type=script&setup=true&lang=js"

import "./enfooter.vue?vue&type=style&index=0&id=23f98995&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23f98995"]])

export default __exports__